
import { Component } from 'vue-property-decorator';
import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
import { Chip, FormFields, FilterFields, TableHeaderModel } from '@/models/repsol-template.model';
import ComponentBase from '@/mixins/componentBase';
import RepsolDialog from '@/components/RepsolDialog.vue';

@Component({
  name: 'MercadosPage',
  components: {
    RepsolFilterBarComponent,
    RepsolFilterChipsComponent,
    RepsolTableComponent,
    RepsolFormPopupComponent,
    RepsolDialog
  },
})



class MercadosPage extends ComponentBase {

  isOpenFilters = false;
  isOpenForm = false;
  formIsValid = true;
  formOnlyRead = false;

  deleteFilter = "";

  popupHeaderText = "";

  filterChips: Chip[] = [];

  filterFields: FilterFields[] = [];

  formFields: FormFields[] = [];

  items: any[] = [];

  itemEdit: any = {};

  tableHeaders: TableHeaderModel[] = [];

  itemEliminar: any = {};

  showDialog = false;

  showMessage = false;

  constructor() {
    super();
  }

  mounted() {
    this.formFields = [
      {
        label: 'common.code',
        name: 'codigo',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 5,
      },
      {
        label: 'common.name',
        name: 'nombre',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 5,
      },
      {
        label: 'mercados.weekend_operation',
        name: 'operaFinDeSemana',
        as: 'radio',
        items: this.maestroSiNo,
        model: '',
        isDisabled: false,
        isRequired: false,
        canView: true,
        cols: 5,
      },
      {
        label: 'common.active',
        name: 'activo',
        as: 'radio',
        items: this.maestroSiNo,
        model: '',
        isDisabled: false,
        isRequired: false,
        canView: true,
        cols: 5
      },
    ];

  // Here to make the new field fileterable
    this.filterFields = [
      {
        label: 'common.code',
        name: 'codigo',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      },
      {
        label: 'common.name',
        name: 'nombre',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      },
    ];

    this.tableHeaders = [
      { text: "common.code", value: "codigo", sortable: true, as: 'text' },
      { text: "common.name", value: "nombre", sortable: true, as: 'text' },
      { text: "mercados.weekend_operation", value: "operaFinDeSemana", sortable: true, as: 'select', items: this.maestroSiNo },
      { text: "common.active", value: "activo", sortable: true, as: 'select', items: this.maestroSiNo },
      {
        text: '', value: "actions", sortable: false, as: '', actions: [
          { icon: 'mdi-close', name: 'eliminar' },
          { icon: 'edit', name: 'editar' }
        ]
      }
    ];

    this.getMercadosList();

    this.getMaestroMercado();
    

  }

  async getMercadosList() {
    this.openSpinner("mercados.cargarListado");

    this.items = [];
    let filtro = {};
    this.filterFields.forEach(f => {
      if (f.model) {
        filtro[f.name] = f.model;
      }
    });

    let route = '/api/mercado/list';
    await this.post({ apiUrl: route, entity: filtro })
      .then(data => {
        this.items = data;
      })
      .catch(error => {
        this.mostrarKO("mercados.koListado");
      })
      .finally(() => {
        this.closeSpinner();
      });
  }

  nuevoElemento(): void {
    this.popupHeaderText = "mercados.nuevoElemento";
    this.itemEdit = { operaFinDeSemana: true, activo: true };
    this.setCodigoDisabled(false); 
    this.isOpenForm = true;
  }

  tableEventAction(action: string, item: any): void {
    switch (action) {
      case 'eliminar':
        this.itemEliminar = item;
        this.showDialog = true;
        break;

      case 'editar':
        this.popupHeaderText = "mercados.editarElemento";
        this.itemEdit = {};
        this.openSpinner("mercados.cargar");
        this.get({ apiUrl: `/api/mercado/${item.codigo}` })
          .then((response) => {
            this.itemEdit = response;
            this.itemEdit["$item_id"] = item.codigo;
            this.setCodigoDisabled(true); 
            this.closeSpinner();
            this.isOpenForm = true;
          })
          .catch(() => {
            this.mostrarKO("mercados.errorCargar");
            this.closeSpinner();

          });
        break;
      default:
        break;
    }
  }

  private setCodigoDisabled(disabled: boolean) {
    const codigoField = this.formFields.find(f => f.name === 'codigo');
    if (codigoField) codigoField.isDisabled = disabled;
  }

  private eliminarMercado() {
    this.showDialog = false;
    this.openSpinner("mercados.eliminarExitosa");
    this.delete({ apiUrl: '/api/mercado', entity: { id: this.itemEliminar.codigo } })
      .then(() => {
        this.closeSpinner();
        this.mostrarOK("mercados.eliminarExitosa");
        this.getMercadosList();
      })
      .catch(() => {
        this.closeSpinner();
        this.mostrarKO("mercados.errorEliminar");
      });
  }

  formEventAction(action: string, item: any): void {
    switch (action) {
      case 'salvar':
        if (item["$item_id"]) {
          this.openSpinner("mercados.actualizarElemento");
          this.put({ apiUrl: `/api/mercado/${item["$item_id"]}`, entity: item })
            .then(() => {
              this.isOpenForm = false;
              this.closeSpinner();
              this.mostrarOK("mercados.actualizacionExitosa");
              this.getMercadosList();
            })
            .catch(() => {
              this.closeSpinner();
              this.mostrarKO("mercados.errorActualizacion");
            });
        } else {
          this.openSpinner("mercados.crearElemento");
          this.post({ apiUrl: '/api/mercado', entity: item })
            .then(() => {
              this.isOpenForm = false;
              this.closeSpinner();
              this.mostrarOK("mercados.creacionExitosa");
              this.getMercadosList();
            })
            .catch(() => {
              this.closeSpinner();
              this.mostrarKO("mercados.errorCreacion");
            });
        }

        break;

      case 'cancelar':
        this.isOpenForm = false;
        break;

      default:
        // Cualquier otro código que necesites manejar para otros casos
        break;
    }
  }

  changeFilters(): void {
    this.filterChips.splice(0);
    this.filterFields.forEach(f => {
      if (f.model) {
        if (Array.isArray(f.model)) {
          f.model.forEach(m => {
            this.filterChips.push({ clave: `${f.name}-${m.id}`, valor: m.nombre, tooltip: f.label });
          })
        }
        else {
          this.filterChips.push({ clave: `${f.name}`, valor: f.model as string, tooltip: f.label });
        }
      }
    });

    this.isOpenFilters = false;

    //hacer la llamada al listado
    this.getMercadosList();

  }

  removeChip(clave: string): void {
    if (clave) {
      this.filterChips = this.filterChips.filter(c => c.clave != clave);

      var name = clave.split('-')[0];
      var field = this.filterFields.find(f => f.name == name);
      if (field) {
        if (Array.isArray(field.model)) {
          var id = clave.split('-')[1];
          field.model = field.model.filter(m => m.id != id);
        }
        else {
          field.model = '';
        }
      }
      this.getMercadosList();
    }
  }

  rulesForm = {
    codigo: [this.required(), this.maxLen(20)],
    nombre: [this.required(), this.maxLen(255)],
    activo: [this.required()],
    operaFinDeSemana: [this.required()]
  };



}

export default MercadosPage;
